import React from 'react';
import BackButton from '../components/BackButton';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const About = () => {
  return (
    <>
      <main className="flex-grow w-full max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop pb-12 md:pb-16 pt-28 md:pt-32">
        <BackButton />
        <Reveal>
        <div className="max-w-3xl mx-auto">
          <header className="mb-12 text-center">
            <h1 className="font-display-lg text-display-lg-mobile md:text-[40px] text-primary mb-4">About TankCare</h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant">Elevating the standard of aquatic hygiene.</p>
          </header>
          
          <div className="bg-surface-container-lowest rounded-2xl p-8 md:p-12 border border-outline-variant/30 shadow-[0_8px_30px_rgba(0,0,0,0.04)] space-y-8">
            <section>
              <h2 className="font-headline-md text-headline-md text-on-surface mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">verified</span>
                Our Mission
              </h2>
              <p className="text-on-surface-variant font-body-md leading-relaxed mb-4">
                TankCare was founded to provide elite, uncompromising hygiene services for high-end aquatic systems, ensuring pristine water quality through cutting-edge technology and certified technicians.
              </p>
              <p className="text-on-surface-variant font-body-md leading-relaxed">
                We believe that clean water is the foundation of health and luxury. Our tailored maintenance protocols are designed for clients who accept nothing but the best.
              </p>
            </section>
          </div>
        </div>
        </Reveal>
      </main>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default About;
